import { render, staticRenderFns } from "./FtpCreate.vue?vue&type=template&id=fa183f04"
import script from "./FtpCreate.vue?vue&type=script&lang=js"
export * from "./FtpCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports